import { createTheme } from "@mui/material/styles";
import { pallete } from "../../libs/pallete";
const fontFam = "Suranna, serif";

export const themeObject = {
  
  palette: {
    primary: { main: "#E46540" },
    secondary: { main: "#fff" },
  },
};

export default createTheme(themeObject);
